'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');

var defaults = { cntry: "US", lang: "en", sourceCode: "UNIFIED", version: "1.0" };

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.token
     * @param {string} params.deviceId
     * @returns {Bluebird Promise}
     */
    get: function get(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().offersAvailable, qs, params);
    },

    /**
     * @param params
     * @param {string} params.token
     * @param {string} params.deviceId
     * @returns {Bluebird Promise}
     */
    redeem: function redeem(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().offersRedeem, qs, params);
    },

    /**
     * @param params
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.apiKey
     * @param {string} params.deviceId
     * @returns {Bluebird Promise}
     */
    getCSO: function getCSO(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().offersAvailableCSO, qs, params);
    },

    /**
     * @param params
     * @param {string} params.loyaltyPhoneNum
     * @param {string} params.apiKey
     * @param {string} params.deviceId
     * @param {Array} params.offerId
     * @param {string} params.eventCode
     * @returns {Bluebird Promise}
     */
    eventCSO: function eventCSO(params) {
        if (!params) {
            throw Error('missing params');
        }

        var qs = this.pullQueryStringParams(params);
        return this.postApiRequest(this.getUrl().offersEventCSO, qs, params);
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/offersServiceClient.js
// module id = 769
// module chunks = 0